var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeeds1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31418 2.07434C5.29187 3.46489 3 9.99931 3 14.9702C3 19.8607 5.2184 21.6182 8.16825 21.9822C5.62957 19.1432 5.16115 15.2414 5.55084 11.5911C5.93759 7.96837 7.1828 4.43797 8.31418 2.07434ZM9.40901 21.0055C7.28233 18.6232 6.78992 15.2317 7.16243 11.7424C7.48545 8.7166 8.44885 5.73552 9.40901 3.53427C10.3692 5.73552 11.3326 8.7166 11.6556 11.7424C12.0281 15.2317 11.5357 18.6232 9.40901 21.0055ZM15.9571 14.9702C15.9571 19.946 13.6606 21.6786 10.6338 22C13.1865 19.1595 13.6577 15.249 13.2672 11.5911C12.8764 7.93019 11.6089 4.36357 10.4681 2C13.5764 3.21348 15.9571 9.9039 15.9571 14.9702Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3046 7.61833C16.1761 7.23978 16.0393 6.86847 15.8945 6.50677C15.841 6.3732 15.7863 6.24044 15.7303 6.10865C17.4093 4.92547 19.0946 4.18601 20.4179 4.26974C19.1911 5.10032 17.7252 6.24828 16.3046 7.61833Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7695 9.1569C17.2637 11.0108 17.5528 12.9559 17.5753 14.7451C17.8616 14.2674 18.1273 13.77 18.3732 13.2588C19.5793 10.7519 20.2623 8.00857 20.5718 5.87732C19.3862 6.73827 18.0388 7.85967 16.7695 9.1569Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3564 17.5214C18.3051 16.4026 19.0806 15.1287 19.7085 13.8237C21.1677 10.7907 21.8948 7.45986 22.1411 5.12488C23.9906 7.39337 22.629 13.6432 20.1859 17.6113C18.7151 20.0003 17.1561 21.0688 15.5879 21.3005C15.6208 21.2644 15.6534 21.2277 15.6857 21.1906C16.5219 20.229 17.075 19.0068 17.3564 17.5214Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeds1);
export default __webpack_public_path__ + "static/media/seeds-1.461562a960a7f9962a65859e26a2d4d5.svg";
export { ForwardRef as ReactComponent };